import React from 'react'
import SpecteraStep1 from './SpecteraStep1'
import SpecteraStep2 from './SpecteraStep2'
import SpecteraFinalStep from './SpecteraFinalStep'
import { connect } from 'react-redux'

function SpecteraFormStep(props) {
  const { specteraAddOnPortalType, pprops: { visionInsuranceClaimForm, claimFormTemplate, saving, editing: { activeModule }, firstStepActionLabel } } = props
  const currentStep = activeModule || 'first'

  return (
    <div className='mt-7'>
      {currentStep === 'first' && <SpecteraStep1 visionInsuranceClaimForm={visionInsuranceClaimForm} actionLabel={firstStepActionLabel} />}
      {currentStep === 'second' &&
        <SpecteraStep2 claimFormTemplate={claimFormTemplate} visionInsuranceClaimForm={visionInsuranceClaimForm} saving={saving}/>
      }
      {currentStep === 'final' &&
        <SpecteraFinalStep claimFormTemplate={claimFormTemplate} visionInsuranceClaimForm={visionInsuranceClaimForm} saving={saving} portalType={specteraAddOnPortalType} />
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsurance } = state
  return {
    specteraAddOnPortalType: visionInsurance?.services?.find(item => item.config.service === "spectera")?.config?.portal_type || false,
  }
}

export default connect(mapStateToProps)(SpecteraFormStep);